import { translation } from 'I18n/i18n'
import AnchorPart from 'components/anchorPart/anchorPart'
import ScrollContainer from 'components/scrollContainer/scrollContainer'
import ScrollSection from 'components/scrollSection/scrollSection'
import AnchorButtonContext from 'contexts/anchorButton'
import CounterContext from 'contexts/counter'
import HeadbandContext from 'contexts/headband'
import englishCondition from 'pages/visiteur/englishAssert'
import { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

interface IProps {
   visiteur?: boolean
}

export default function Qualité(props: IProps) {
   const lang = useSelector((state: any) => state.languageReducer.language)
   const [altLanguage, setAltLanguage] = useState(englishCondition(lang, props.visiteur))
   const { setAnchorButton } = useContext(AnchorButtonContext)
   const { setCounter, counterDefault } = useContext(CounterContext)
   const { setHeadband } = useContext(HeadbandContext)

   useEffect(() => {
      setCounter(counterDefault)
      setHeadband(translation(lang, 'qualite', 'title'))
      setAnchorButton(
         translation(lang, 'qualite', props.visiteur ? 'anchorBtnsVisitor' : 'anchorBtns'),
      )
   }, [])

   return (
      <ScrollContainer>
         <AnchorPart
            anchor={{ partName: translation(lang, 'qualite', 'anchorBtnsVisitor')[0], id: 0 }}
         />
         <ScrollSection zoneName={altLanguage ? 'Quality policies' : 'Politiques qualité'} />
         <AnchorPart
            anchor={{ partName: translation(lang, 'qualite', 'anchorBtnsVisitor')[1], id: 1 }}
         />
         <ScrollSection
            zoneName={altLanguage ? 'Quality certifications' : 'Certifications qualité'}
         />
         {!props.visiteur && (
            <>
               <AnchorPart anchor={{ partName: 'POLITIQUE ENVIRONNEMENT', id: 2 }} />
               <ScrollSection
                  zoneName={altLanguage ? 'Environment policies' : 'Politique environnement'}
               />
            </>
         )}
      </ScrollContainer>
   )
}
